import * as React from 'react';
import { translate } from 'react-i18next';
import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

const ErrorModal = ({ t, closeModal, errorMessage, title }) => (
  <MessageBoxFunctionalLayout
    title={t(title || 'modal.errorModal.title')}
    cancelText={t('modal.errorModal.buttonText')}
    onCancel={closeModal}
    onClose={closeModal}
    theme="red"
    dataHook="errorRoleModal">
      <Text size="medium" weight="thin">{t(errorMessage || 'modal.errorModal.text')}</Text>
  </MessageBoxFunctionalLayout>
);

export default translate()(ErrorModal);
